import React from "react";
import { Typography } from '@mui/material';
import { LockOutlined as Icon } from '@mui/icons-material';
import Auth from '../auth';

interface BillableOnlyProps {
    isBillable?: boolean;
    [key: string]: any;
}

interface BillingEnabledOnlyProps {
    billingEnabled?: boolean;
    [key: string]: any;
}

function billableOnly<P extends object>(WrappedComponent: React.ComponentType<P>){
    return (props: P & BillableOnlyProps) => {
        let style = {fontSize: '16pt'};
      if(!props.isBillable){
          return <div style={{color: '#888'}}>
              <Icon style={{fontSize: "20em"}}/>
              <Typography style={style}>
                Sorry, this page is only available to users with a Logicbroker subscription.
              </Typography>
          </div>;
      }
      return <WrappedComponent {...props as unknown as P} />;
    };
}

function BillingEnabledOnly<P extends object>(WrappedComponent: React.ComponentType<P>){
    return (props: P & BillingEnabledOnlyProps) => {
        let style = {fontSize: '16pt'};
      if(!props.billingEnabled || !Auth.hasPermission("billing/manage")){
          return <div style={{color: '#888'}}>
              <Icon style={{fontSize: "20em"}}/>
              <Typography style={style}>
                Sorry, this page is only available to users with a Logicbroker subscription and billing management permissions.
              </Typography>
          </div>;
      }
      return <WrappedComponent {...props as unknown as P} />;
    };
}

const billingEnabledOnly = <P extends object>(component: React.ComponentType<P>) => BillingEnabledOnly(component);

const billableOnlyExport = <P extends object>(component: React.ComponentType<P>) => billableOnly(component);
export default billableOnlyExport;

export { billingEnabledOnly };
